import { VenueActionAccessRequest } from '../../graphql/API';
import { venueActionAccessRequest } from '../../graphql/mutations';
import { executeGql, processGqlResult } from '../../utils/gql-utils';

export const venueActionAccessRequestApi = async (
  input: VenueActionAccessRequest,
): Promise<{ success: boolean; message?: string; reservationID?: string }> => {
  const result = await executeGql(venueActionAccessRequest, {
    input,
  });
  const response = JSON.parse(processGqlResult<string>('venueActionAccessRequest', result));
  return response;
};
